import { requestGet, api } from "../config/Api";

const name = 'job/histories'

export const getJobHistories = (data) => {
  return requestGet(name, data);
};

export const downloadJobHistoryReport = (jobHistoryId) => {
  return api.get(`${name}/${jobHistoryId}/report`, {
    responseType: "blob",
  });
};